import { TableRowProps } from "../../molecules/TableRow/TableRowAtom";
import {
  createInfoCell,
  createClickableCell,
  createCellWithChildren,
} from "../../utilities/CreateCell";
import { createRow } from "../../utilities/CreateRow";
import { cancellationCellStyles } from "./CreateLabelsTable.styles";

export const createLabelsRows = (
  data: any,
  isAdmin: boolean,
  history: any,
  handleCancellation: (entry: any) => void
) => {
  const rows: Array<TableRowProps> = [];

  const createCancellationCell = (entry: any) => {
  const isCancelled = entry.cancelled;

  return createCellWithChildren(
    <div
      onClick={() => {
        if (!isCancelled) {
          handleCancellation(entry);
        }
      }}
      style={cancellationCellStyles(isCancelled)}
      title={isCancelled ? "Already cancelled" : "Click to cancel"}
    >
      {isCancelled ? "Cancelled" : "Cancel"}
    </div>
  );
};

  data.forEach((entry: any) => {
    const row: TableRowProps = createRow(
      createInfoCell(entry.pickupDate), //Pickup Date
      createInfoCell(entry.trackingNumber), //Tracking Number
      createClickableCell((event) => {
        history.push(
          `/pharmacies/${entry.returnRequest.pharmacy.id}/returnrequests/${entry.returnRequest.id}/shipments/${entry.id}/label`
        );
      }, "View Shipping Label"), // View Shipping Label
      createInfoCell((!entry.shipmentStatus || entry.shipmentStatus.includes("null")) ? "-" : entry.shipmentStatus), // Status
      // createCancellationCell(entry),
    );
    rows.push(row);
  });
  return rows;
};
